import * as appJson from '../../package.json';
export const PRODUCT_NAME = appJson.productName;
export const VERSION = appJson.version;
